export const physiologyModule = {
  id: "physiology",
  title: "Brain Physiology",
  sections: [
    {
      type: "text",
      content:
        "<p>The brain controls all bodily functions through electrical and chemical signals. This module covers neurotransmission, brain metabolism, and neural pathways.</p>",
    },
    {
      type: "text",
      content:
        "<p>Content coming soon. Add your physiology content here.</p>",
    },
  ],
};
